module.exports = {
  apiUrl: "https://api.dev.confcloud.de/v1",
  showDevTools: true
};
